import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
const values = [{
  title: 'Craft over volume',
  body: 'We publish few titles, each given the editorial care and design attention it deserves.'
}, {
  title: 'Wisdom traditions',
  body: "Our list explores history, philosophy, and spirit, works that ask enduring questions."
}, {
  title: 'Author partnership',
  body: 'We work closely with our authors from first draft to final printed page.'
}];
export function About() {
  return <section id="about" className="w-full bg-ink text-paper py-28" data-id="element-10" data-mp="38p1m87dev5v8">
      <div className="mx-auto max-w-6xl px-6" data-id="element-11" data-mp="3dgjco1ht5o1y">
        <SectionHeading dark align="left" eyebrow="Our Story" title="A small press with a long memory" description="Founded on the belief that a well-made book can change how a reader sees the world, Deleon Publishing LLC brings together timeless subjects and meticulous craft." data-id="element-12" data-mp="3dhurcwcskg7u" />

        <div className="mt-16 grid md:grid-cols-3 gap-10" data-id="element-13" data-mp="3rhm28o80hghm">
          {values.map((v, i) => <motion.div key={v.title} initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.12
        }} className="border-t border-gold/40 pt-6" data-id="element-14" data-mp="2lrh6xpniq56j" data-mpi={i}>
              <h3 className="font-serif text-2xl text-gold-light mb-3" data-id="element-15" data-mp="27t0q35vxyyao">
                {v.title}
              </h3>
              <p className="text-paper/70 leading-relaxed" data-id="element-16" data-mp="34jt8wba9f4g5">{v.body}</p>
            </motion.div>)}
        </div>

        <div className="mt-20 grid sm:grid-cols-3 gap-8 border-t border-white/10 pt-12 text-center" data-id="element-17" data-mp="30ihfrvs6g137">
          {[['3', 'Books in print'], ['2010', 'Founded'], ['∞', 'Stories to tell']].map(([stat, label]) => <div key={label} data-id="element-18" data-mp="2qohfc77ubk0t">
              <p className="font-serif text-5xl text-gold-light" data-id="element-19" data-mp="3o67qo0y5r0pt">{stat}</p>
              <p className="text-paper/60 text-sm mt-2 tracking-wide uppercase" data-id="element-20" data-mp="3o7iq5okklmb4">
                {label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}